import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyBoardRoute: InvariantJiraRoute = {
	name: 'legacy-board',
	path: '/secure/RapidBoard.jspa',
};
